<template>
    <div
        ref="itemRef"
        @click="handleClickItem"
    >
        <component :is="component" v-bind="{ ...extraProps, source, index }" />
    </div>
</template>
<script lang="ts">
export default {
    name: 'Item',
};
</script>
<script lang="ts" setup>
import { watch, onUpdated } from 'vue';
import type { Ref, ComponentPublicInstance } from 'vue';
import useMeasure from '../../hooks/useMeasure';

interface Props {
    index: number;
    horizontal: boolean;
    source: any;
    component: ComponentPublicInstance;
    uniqueKey: string | number;
    extraProps?: Record<string, any>;
    isSizeImmutable: boolean;
}

const props = defineProps<Props>();
const emit = defineEmits(['resize', 'click']);

let itemRef: Ref<HTMLElement> | null = null;

if (!props.isSizeImmutable) {
    const shapeKey = props.horizontal ? 'width' : 'height';

    const measureRes = useMeasure({ wait: 666, type: 'throttle' });
    itemRef = measureRes[0];
    const rect = measureRes[1];

    watch(() => rect[shapeKey], () => emit('resize', props.uniqueKey, rect[shapeKey], true));
    onUpdated(() => emit('resize', props.uniqueKey, rect[shapeKey]));
}


const handleClickItem = () => emit('click');
</script>